<template>
  <div class="container-fluid">
    <div class="row">
      <FinancesPartnersModal
        v-model="createModal.show"
        :countries="getCountries"
        @hide="hideCreateModal"
        @submit="createFinancePartner"
      />
      <FinancesPartnersModal
        v-model="editModal.show"
        :title="editModal.title"
        :countries="getCountries"
        :data="editModal.data"
        @hide="hideEditModal"
        @submit="editFinancePartner"
      />

      <div class="col-12">
        <div class="page-table-header">
          <PageHeader :page-title="'Partners'">
            <template v-slot:buttons>
              <b-button
                class="button title-container__controls-item"
                :variant="isShowFilter ? 'secondary' : 'info'"
                @click="toggleShowFilter"
              >
                <span class="material-icons icon-image-preview">
                  tune
                </span>
                Filters
              </b-button>
              <b-button
                v-if="$can('create-finances_partners')"
                variant="success"
                class="button"
                @click="showCreateModal"
                :disabled="isDataPageLoading"
              >
                Create
              </b-button>
            </template>
          </PageHeader>

          <Filters
            v-if="$can(permissions.ReadAllFinancesClients)"
            v-show="isShowFilter"
            textButtonSubmit="Filter"
            :data="getTableFilters"
            :isLoading="isDataPageLoading"
            @submit="setFilterClients"
          />

          <TableForPage
            ref="table"
            :tableData="getTableData"
            :fields="getTableFields"
            :perPage="getPartners.per_page"
            :currentPage="getPartners.current_page"
            :totalRows="getPartners.total"
            :isEdit="$can('update_all-finances_partners')"
            :isRemove="$can('update_all-finances_partners')"
            isServerRender
            noLocalSorting
            @remove="removePartner"
            @edit="showEditModal"
            @update="updatePartners"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { permissions } from '@mocks/permissions'
import FinanceClientsPartners from '@/mixins/FinanceClientsPartners'
import PageHeader from '@components/PageHeader'
import Filters from '@components/Filter/Filter'
import FinancesPartnersModal from '@components/modals/FinancesPartnersModal'
import TableForPage from '@tables/TableForPage'
import { mapGetters } from 'vuex'

export default {
  mixins: [FinanceClientsPartners],
  components: {
    PageHeader,
    FinancesPartnersModal,
    Filters,
    TableForPage
  },
  data () {
    return {
      permissions
    }
  },
  computed: {
    ...mapGetters({
      getPartners: 'partners/getPartners'
    }),
    getTableFilters () {
      return this.filters || {}
    },
    getTableFields () {
      const currentFields = this.table.fields.filter(field => field.key !== 'projects')
      return currentFields || []
    },
    getTableData () {
      return this.getPartners.data || []
    },
    getTableRowModal () {
      const currentTableRowModal = this.tableRowModal.fields.filter(field => field.key !== 'project.name')
      return currentTableRowModal || []
    }
  },
  methods: {
    fetchAllData () {
      Promise.all([
        this.fetchPartners(),
        this.fetchCountries()
      ])
        .then(() => {
          // this.setAllOptionsFilter()
        })
    },
    setAllOptionsFilter () {
      this.getTableFilters.partners.options = this.getProjects
    },
    fetchPartners () {
      let params = this.table.params.currentPage

      if (this.table.params.sorting) {
        params += this.table.params.sorting
      }
      if (this.table.params.filters) {
        params += this.table.params.filters
      }

      this._toggleDataPageLoading(() => this.$api.partners.getPartners(params))
    },
    setFilterClients (data) {
      this.setParamsFilters(data)
      this.setParamsCurrentPage()
      this.fetchPartners()
    },
    setParamsFilters (data) {
      const filters = Object.values(data).reduce(function (state, current) {
        if (current['value']) {
          const value = typeof current['value'] === 'object'
            ? current['value'][current['valueField']] : current['value']
          state += `&filter[${current.name}]=${value}`
        }
        return state
      }, '')

      this.table.params.filters = filters || null
    },
    updatePartners (data) {
      if (!data) return this.fetchPartners()

      const { currentPage, sortDesc, sortBy } = data

      this.setParamsCurrentPage(currentPage)
      this.setParamsSort(sortDesc, sortBy)

      this.fetchPartners()
    },
    async createFinancePartner (fields) {
      const data = this.prepareDataForEditAndCreateRequest(fields)

      this._toggleDataPageLoading(async () => {
        await this.$api.partners.createPartner(data)
        this.$snotify.success(
          'Partner successfully created',
          'Success',
          this.$store.state.snotify
        )
        this.hideCreateModal()
        this.updatePartners()
      })
    },
    async editFinancePartner (fields) {
      const data = this.prepareDataForEditAndCreateRequest(fields)

      this._toggleDataPageLoading(async () => {
        await this.$api.partners.editPartner(data)
        this.$snotify.success(
          'Partner updated successfully',
          'Success',
          this.$store.state.snotify
        )
        this.hideEditModal()
        this.updatePartners()
      })
    },
    async removePartner (item) {
      const confirm = await this.$root.$confirm.open(
        'Delete',
        'Are you sure you want to delete the partner?'
      )

      if (!confirm) return

      this._toggleDataPageLoading(async () => {
        const deleteResponse = await this.$api.partners.removePartner(item.id)
        this.$snotify.success(
          deleteResponse.data,
          'Success',
          this.$store.state.snotify
        )
        this.updatePartners()
      })
    }
  }
}
</script>

<style>

</style>
